import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      mainTitle: {
        marginTop: '24px',
      },
      subhead: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 'bold',
        color: sicrediColors.secondarySicrediDarker,
        marginTop: theme.spacing(1),
      },
      input: {
        maxWidth: 622,
        position: 'absolute',
        top: '35%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      },
      clearIcon: {
        fontSize: 9,
      },
      closeIcon: {
        color: sicrediColors.primarySicrediDark,      
      },
      searchIcon: {
        color: sicrediColors.primarySicrediDark,
        fontSize: '18px',
      },
      header: {
        margin: theme.spacing(2, 0, 1),
        '& *': {
          boxSizing: 'border-box',
        },
        '& > h1': {
          marginBottom: theme.spacing(2),
        }
      },
      content: {
        '& *': {
          boxSizing: 'border-box',
        },
      },
    }),
  { name: 'VotoPresencial' }
);
